export default class PlanoContaItem {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.planoContaId = 0;
        this.planoContaContabilId = 0;
        this.criterioAssociacaoContabil = 'U';
        this.planoContaContabilLivreId = 0;
        this.planoContaContabilRestritoId = 0;
        this.nome = '';
        this.descricao = '';
        this.ativo = true;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.planoContaId = model.planoContaId;
        this.planoContaContabilId = model.planoContaContabilId;
        this.planoContaContabil = model.planoContaContabil;
        this.criterioAssociacaoContabil = model.criterioAssociacaoContabil || 'U';
        this.planoContaContabilLivreId = model.planoContaContabilLivreId;
        this.planoContaContabilLivre = model.planoContaContabilLivre;
        this.planoContaContabilRestritoId = model.planoContaContabilRestritoId;
        this.planoContaContabilRestrito = model.planoContaContabilRestrito;
        this.nome = model.nome; 
        this.descricao = model.descricao;
        this.ativo = model.ativo;
    }
}
